import React, { useState } from "react";

export default function DeleteModal({ show, onCancel, onDelete }) {
  const [selected, setSelected] = useState(null);

  if (!show) return null;

  const handleSelect = (option) => {
    setSelected(option);
    setTimeout(() => {
      onDelete(option);
      setSelected(null);
    }, 200);
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <p className="modal-title">Delete message?</p>
        <button
          className={selected === "everyone" ? "selected" : ""}
          onClick={() => handleSelect("everyone")}
        >
          Delete for everyone
        </button>
        <button
          className={selected === "me" ? "selected" : ""}
          onClick={() => handleSelect("me")}
        >
          Delete for me
        </button>
        <button onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
